import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.4_@types+node@24.10.9_better-sqlite3@11.10.0_cac@6.7.14_db0@0_7vnhgue7fxrclk64dldu6fqlue/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}